import "./style.scss";
import { useForm } from "react-hook-form";
import { userRoles } from "@/src/constants/userRoles";
import ArrowSelect from "@/src/svg/applyOnline/ArrowSelectSvg";
import { userAuthRequests } from "@/src/api/userInfoRequests";

type FormValues = {
  login: string;
  password: string;
  email: string;
  role: string;
};

const UPRegistration = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    console.log(data);
    try {
      const userAuthInfo = await userAuthRequests.singUp(data);
      console.log("create user", userAuthInfo);
      alert("Успіх! Новий користувач зареєстрований.");
    } catch (error) {
      console.error("Ошибка при входе:", error);
      alert("От халепа! Сталась помилка при створюванні.");
    }
  };

  return (
    <div className="user-page-registration">
      <p className="user-page-title">Registration new user:</p>
      <form onSubmit={handleSubmit(onSubmit)} className="sing-up">
        <div className="sing-up-input">
          <label htmlFor="login">Логин</label>
          <input
            id="login"
            type="text"
            placeholder="Введите логин"
            {...register("login", { required: "Введите логин" })}
          />
          {errors.login && <p>{errors.login.message}</p>}
        </div>
        <div className="sing-up-input">
          <label htmlFor="password">Пароль</label>
          <input
            id="password"
            type="password"
            placeholder="Введите пароль"
            {...register("password", {
              required: "Введите пароль",
              minLength: {
                value: 6,
                message: "Пароль должен быть не менее 6 символов",
              },
            })}
          />
          {errors.password && <p>{errors.password.message}</p>}
        </div>
        <div className="sing-up-input">
          <label htmlFor="password">Email</label>

          <input
            type="email"
            placeholder="Email:"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Invalid email address",
              },
            })}
          />
          {errors.email && <p>{errors.email.message}</p>}
        </div>

        <div className="sing-up-input select">
          <label htmlFor="role">Role</label>

          <select
            defaultValue=""
            id="role"
            {...register("role", {
              required: "Пожалуйста, выберите роль",
            })}
          >
            {userRoles.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>

          <ArrowSelect />

          {errors.role && <p className="error-message">{errors.role.message}</p>}
        </div>

        <button className="sing-up-button" type="submit">
          Зареєструвати
        </button>
      </form>
    </div>
  );
};

export default UPRegistration;
